<div class="main-content">
	<div class="container-fluid">
		<div class="row">
			<div class="col-md-12">
				<div class="card">
					<div class="card-header card-header-{{color}}-6">
						<h4 class="card-title"><i class="material-icons" (click)="back()">arrow_left</i> Vendor Product Customer Sales
						</h4>
						<p class="card-category text-right">CVSLS</p>
					</div>
					<div class="card-body">
						<app-cvsls-content [customer]="customer" [name]="name"></app-cvsls-content>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>
